import { Action } from "./Action"
import { Condition } from "./Condition"
import { Trigger } from "./Trigger"
import {Employee} from "../../hooks/useEmployeeAutocomplete";
import {SecondaryAutomations} from "./SecondaryAutomations";
export type AutomationStatusType = 'active' | 'inactive' | 'ACTIVE' | 'INACTIVE'
export type AutomationType = 'ON_DEMAND' | 'AUTOMATED'
export type AutomationObject = 'REQUISITION' | 'CANDIDATE'

declare global {
    interface Window {
        secondaryAutomationEngineEnabled: boolean;
    }
}

export interface AutomationSearchResult {
    companyAutomationId: string
    name: string
    status: AutomationStatusType
    automationType: AutomationType
    automationObject: AutomationObject
    companyFilters: Array<Condition>
    companyActions: Array<Action>
    linkedAutomations: Array<SecondaryAutomations>
    lastUpdatedDate: string
    lastUpdateUserFullName: string
    displayFilters: string
    displayActions: string
    actionUser: Employee
    triggerType: string
}

export interface Automation {
    eId: string
    account: {
        EId: string
        username: string
        email: string
    }
    name: string
    status: AutomationStatusType
    type: AutomationType
    trigger: AutomationObject
    triggers: Array<Trigger>
    conditions: Array<Condition>
    actions: Array<Action>
    lastUpdated: number
    lastUpdatedBy: {
        EId: string
        username: string
        email: string
    }
}

export const DefaultAutomationType = 'AUTOMATED'